<template>
  <div class="confirm_container">
    <div class="main">
      <p class="title">{{ title }}</p>
      <p v-if="subTitle" class="sub_title">{{ subTitle }}</p>
      <div class="btn_con">
        <template v-if="cancelText">
          <div class="btn" @click="$emit('cancel', 'cancel')">{{ cancelText }}</div>
          <div class="line"></div>
        </template>
        <div class="btn" @click="$emit('ok', 'ok')">{{ okText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'subTitle', 'cancelText', 'okText'],
  data() {
    return {}
  },
  methods: {},
}
</script>
<style scoped lang="less">
@import '../assets/css/zIndex.less';

.confirm_container {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: @confrim_modal;
  animation: fadeIn 200ms ease;
  display: flex;
  align-items: center;
  justify-content: center;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .main {
    min-width: 500px;
    background: #fff;
    border-radius: 16px;
    text-align: center;
    transform: scale(0.7);
    .title {
      font-size: 30px;
      color: #202226;
      padding: 48px 0 32px;
    }
    .sub_title {
      font-size: 24px;
      color: #626d79;
      padding: 0 63px 20px;
    }
  }
  .btn_con {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 92px;
    border-top: 1px solid #c0bebe;
    .line {
      width: 1px;
      background: #c0bebe;
      height: 100%;
    }
    .btn {
      font-weight: bold;
      font-size: 30px;
      color: #000000;
      cursor: pointer;
    }
  }
}
@media (max-width: 1024px) {
  .confirm_container {
    .main {
      min-width: 5rem;
      border-radius: 0.16rem;
      transform: scale(1);
      .title {
        font-size: 0.3rem;
        padding: 0.48rem 0 0.32rem;
      }
      .sub_title {
        font-size: 0.24rem;
        padding: 0 0.63rem 0.2rem;
      }
    }
    .btn_con {
      height: 0.92rem;
      .line {
        width: 1px;
      }
      .btn {
        font-size: 0.3rem;
      }
    }
  }
}
</style>
